import { Subject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { tap } from 'rxjs/operators';

const DEFAULT_BROWSER_TITLE = 'WMG Sync Licensing';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  browserTitle$: Subject<string> = new Subject<string>();

  constructor(private core: Title) {
    this.browserTitle$.pipe(tap(title => this.core.setTitle(title || DEFAULT_BROWSER_TITLE))).subscribe();
  }

  setBrowserTitle(title: string = null): void {
    this.browserTitle$.next(title || DEFAULT_BROWSER_TITLE);
  }

  getBrowserTitle(): Observable<string> {
    return this.browserTitle$.asObservable();
  }
}
